import "angular-drag-and-drop-lists";

import { CfDatepickerComponent } from "./components/cf-datepicker/cf-datepicker.component";
import { CfUserPickerComponent } from "./components/cf-user-picker/cf-user-picker.component";
import { EditableCustomFieldsComponent } from "./components/editable-custom-fields/editable-custom-fields";
import { CustomFieldCtrl } from "./controllers/custom-field";
import { CustomFieldsCtrl } from "./controllers/custom-fields";
import { CustomFieldActions } from "./redux/custom-field-actions";
import { CustomFieldService } from "./services/customFieldService";
import { SessionSelectorComponent } from "./components/session-selector/session-selector.component";
import { SpecifySessionComponent } from "./components/specify-session/specify-session.component";
import { SessionListSelectorComponent } from "./components/session-list-selector/session-list-selector.component";
import { localize } from "@gtmhub/localization";
import { capitalize } from "@gtmhub/util";
import { ICustomField, localizeGHGridColName } from ".";
import { QuerySessionsService } from "./services/query-sessions.service";
import { CustomFieldModalService } from "@gtmhub/customFields/custom-fields-modal.service";
import { CustomFieldsCellComponent } from "./components/cf-cell/cf-cell.component";

const mod = angular
  .module("customFields", ["dndLists"])
  .controller("CustomFieldsCtrl", CustomFieldsCtrl)
  .controller("CustomFieldCtrl", CustomFieldCtrl)
  .service("CustomFieldService", CustomFieldService)
  .service("CustomFieldActions", CustomFieldActions)
  .service("QuerySessionsService", QuerySessionsService)
  .service("CustomFieldModalService", CustomFieldModalService)
  .component("editableCustomFields", EditableCustomFieldsComponent)
  .component("cfDatepicker", CfDatepickerComponent)
  .component("cfUserPicker", CfUserPickerComponent)
  .component("sessionSelector", SessionSelectorComponent)
  .component("specifySession", SpecifySessionComponent)
  .component("sessionListSelector", SessionListSelectorComponent)
  .component("cfCell", CustomFieldsCellComponent);

mod.filter("customField", function () {
  return function (customField: ICustomField, detailType: string) {
    const targetTypes = {
      goal: capitalize(localize("objective")),
      metric: localize("key_result_cap"),
      metric_snapshot: localize("key_result_update"),
      team: localize("team_cap"),
      task: capitalize(localize("task")),
      user: localize("user"),
    };

    const visualizationKinds = {
      "gtmhub.text": localize("text_field"),
      "gtmhub.textarea": localize("text_area"),
      "gtmhub.select": localize("drop_down_menu"),
      "gtmhub.multiselect": localize("multi_select_list"),
      "gtmhub.datepicker": localize("date_picker"),
      "gtmhub.selectassignee": localize("user_team_selector"),
    };

    switch (detailType) {
      case "targetType":
        return targetTypes[customField.targetTypes[0]] ? targetTypes[customField.targetTypes[0]] : "";
      case "visualizationKind":
        return visualizationKinds[customField.visualizationKind] ? visualizationKinds[customField.visualizationKind] : "";
      default:
        return "";
    }
  };
});

mod.filter("localizeGHGridColName", localizeGHGridColName);

export default mod.name;
